import { useEffect, useRef, useState } from "react";

/**
 * Bungkus judul halaman + tombol aksi + filter (apa saja yang harus tetap
 * diam saat tabel di bawahnya di-scroll). Menempel di top-14 (mobile, pas
 * di bawah header hamburger AppLayout) / top-0 (desktop) — relatif thd
 * kolom konten AppLayout yang scroll, BUKAN window (window tidak pernah
 * scroll sejak layout app-shell diterapkan, lihat AppLayout.jsx).
 *
 * bg-slate-50 solid: mencegah tabel yang scroll di baliknya tembus/terlihat.
 * Shadow tipis muncul begitu benar2 menempel — dideteksi lewat sentinel +
 * IntersectionObserver (bukan window.scrollY, krn itu tidak pernah berubah
 * di layout ini; scroll sesungguhnya terjadi di elemen lain).
 */
export default function StickyHeader({ children, className = "" }) {
    const sentinelRef = useRef(null);
    const [stuck, setStuck] = useState(false);

    useEffect(() => {
        const el = sentinelRef.current;
        if (!el) return;
        const observer = new IntersectionObserver(
            ([entry]) => setStuck(!entry.isIntersecting),
            { threshold: 0 }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        // display:contents: sentinel + sticky-div jadi tampak sbg anak langsung dari
        // root halaman (yg tingginya = seluruh konten, ribuan px), BUKAN dibungkus div
        // biasa yg tingginya cuma setinggi header ini sendiri (~200an px). Kalau dibungkus
        // div biasa, "containing block" sticky jadi cuma setinggi wrapper itu -> begitu
        // scroll lewat situ, sticky kehabisan "ruang" utk terus menempel & malah ikut
        // ter-scroll (persis bug yg mau diperbaiki, cuma pindah lokasi).
        <div className="contents">
            <div ref={sentinelRef} aria-hidden="true" className="h-px" />
            <div
                data-testid="sticky-page-header"
                className={`sticky top-14 md:top-0 z-10 bg-slate-50 space-y-4 pb-2 transition-shadow duration-200 ${stuck ? "shadow-md" : ""} ${className}`}
            >
                {children}
            </div>
        </div>
    );
}
